import Image from "next/image";
import "./index.scss";
import Link from "next/link";

export default function Header() {

  return (
    <header className="header-area rounded-b-lg tracking-wide z-50 md:absolute relative top-0 inset-x-0 max-w-5xl mx-auto">
      {/* Main Navbar Section */}
      <div className="flex flex-wrap items-center justify-center gap-4 px-4 py-3 relative header-inner">
        {/* Logo for large screens */}
        <Link className="cursor-pointer lg:hidden" href="/">
          <Image
            width={150}
            height={62}
            src="/shared/logo.webp"
            alt="Logo"
            priority
          />
        </Link>

        <a
          href="https://www.tablacuisine.com/" target="_blank"
          className="cursor-pointer lg:hidden text-center uppercase rounded text-[12px] bg-red-800 hover:bg-red-900 px-3 py-3 text-white inline-block"
        >
          Visit Tablacuisine
        </a>


        {/* Collapsible menu for small screens */}
        <div
          id="collapseMenu"
          className={`w-full lg:block max-lg:hidden max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50 block}`}
        >

          {/* Menu Content */}
          <div className="lg:flex max-lg:space-y-2 justify-center items-center">
            {/* Left Menu Items */}
            <ul className="lg:flex lg:gap-x-8 max-lg:space-y-2">
              {[{ name: 'Home', scrollTo: '/#home' }, { name: 'About', scrollTo: '/#about' }, { name: 'Order', scrollTo: '/#order' }].map((item, index) => (
                <li key={index} className="max-lg:border-b max-lg:py-3">
                  <Link
                    href={item?.scrollTo}
                    className="header-text cursor-pointer font-bold block nav-link"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Logo in the center on small screens */}
            <Link href="/" className="cursor-pointer mx-16">
              <Image
                width={150}
                height={62}
                src="/shared/logo.webp"
                alt="Logo"
                priority
              />
            </Link>

            {/* Right Menu Items */}
            <ul className="lg:flex lg:gap-x-8 max-lg:space-y-2">
              {[{ name: 'Recognized By', scrollTo: '/#recognized-by' }, { name: 'Menu', scrollTo: '/#menu' }, { name: 'FAQ', scrollTo: '/#faq' }].map((item, index) => (
                <li key={index} className="max-lg:border-b max-lg:py-3">
                  <Link
                    href={item?.scrollTo}
                    className="header-text cursor-pointer font-bold  block nav-link"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}
